module.exports = __webpack_public_path__ + "files/b193274ef353fa45938311f9b26bd7de.svg";